"use client";
import React, { ViewTransition } from "react";
import Link from "next/link";
import { GameCard } from "modules/cards/model/card";
import { CardPreviewLoading } from "modules/common/components/CardPreviewLoading";
import { CardFinishPrices } from "modules/cards/components/CardFinishPrices";
import { getCardUrl } from "utils/utils";
import { ResponsiveCardSizing } from "utils/styles";
import { useCardModal } from "modules/cards/stores/useCardsStore";
import {
  hasFoilVisual,
  primaryAvailableFinish,
} from "modules/cards/model/finishBehavior";

interface PrintingGridCardProps {
  card: GameCard;
  /** Pairs the thumb with the target card page's hero image (page use only). */
  viewTransitionName?: string;
}

export function PrintingGridCard({
  card,
  viewTransitionName,
}: PrintingGridCardProps) {
  const { closeModal } = useCardModal();

  const finish = primaryAvailableFinish(card.finishes);
  const isFoil = hasFoilVisual(card.finishes);

  const preview = (
    <CardPreviewLoading
      sizing={ResponsiveCardSizing}
      card={card}
      foil={isFoil}
    />
  );

  return (
    <Link
      href={getCardUrl(card, finish)}
      onClick={closeModal}
      aria-label={`View ${card.name}`}
      className="relative block w-full"
    >
      {viewTransitionName ? (
        <ViewTransition
          name={viewTransitionName}
          share="vt-hero"
          default="none"
        >
          {preview}
        </ViewTransition>
      ) : (
        preview
      )}
      <CardFinishPrices
        card={card}
        className="badge badge-soft border-base-content/10 bottom-4.5 absolute left-0 right-0 mx-auto items-center border"
      />
    </Link>
  );
}
